<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
#main
	// height:100%
	// background:#ffffff
	background:rgba(255,255,255,1);
	box-shadow:0px 0px 20px rgba(50,92,146,0.1);
	border-radius:18px;
	width:1457px;
	height:750px;
	.box
		display:flex
		height:100%
		.box-l
			min-width:290px
			height:100%
			border-right:1px solid #eeeeee
			.box-top
				height:60px
				line-height:60px
				border-bottom:1px solid #eeeeee
				font-size:14px
				color:rgba(0,84,116,1);
				// display:flex
				// padding:0 0 0px 25px
				text-align:center;
				.l-title
					font-size:20px;
					// border-bottom:2px solid rgba(0,84,116,1);
			.box-list
				height:calc(100% - 60px)
				overflow-y:auto
				.list
					width:100%
					background:#ffffff
					height:63px
					display:flex
					align-items:center
					font-size:14px
					cursor:pointer
					border-bottom:1px solid rgba(246,246,246,1);
					&.active
						background:rgba(0,84,116,1)
						color:#ffffff
					img
						width:46px
						height:46px
						border-radius:50%
						margin-left:25px
					.list-desc
						margin-left:10px
						.list-name
							color:#333333
							&.active
								color:#ffffff
						.list-mes
							color:#999999
							&.active
								color:#ffffff
		.box-r
			min-width:900px
			height:100%
			.box-r-l
				display:flex
				// padding:50px 0 0 0 
				height:100%
				.info
					min-width:450px
					padding-left:60px
					// height:600px
					height:calc(100% - 40px)
					overflow-y:auto
					.top-title
						height:60px
						line-height:60px
						color:#005474
						font-size:20px
					.info-title
						color:#333333
						font-size:14px
						font-weight:bold
						margin:10px 0
					.infos
						font-size:14px
						color:#999999
						padding:5px 0
						.infos-desc
							color:#333
					.talk
						margin-top:30px
						.talk-title
							color:#333333
							font-size:14px
							font-weight:bold
							margin:10px 10px 10px 0
						.talks
							width:350px
							font-size:14px
							color:#999999
							// height:40px
							// line-height:40px
							padding:9px 0
							// display:flex
							.talk-desc
								color:#333
							.talk-input
								width:200px
						.btns
							margin:15px 0 10px 0px
				.mes
					width:830px
					// min-width:540px
					// height:600px
					height:calc(100% - 40px)
					overflow-y:auto
					padding:0 20px 0 50px
					.mes-title
						height:60px
						line-height:60px
						color:#005474
						font-size:20px
						margin-bottom:10px;
					.timeline-title
						cursor:pointer
						span
							font-weight:blod
					.timeline-list
						margin-top:10px
						.timeline-lists
							margin-bottom:5px
							.isuser
								color:#f9569f
								font-size:14px
							.iskf
								color:#4e9b52
								font-size:14px
							.isls
								color:#1890ff
								font-size:14px
							.timeline-message
								color:#999999
								font-size:14px
</style>
<style lang="stylus">
	.mes
		.el-timeline-item__node--primary
			background:#005474 !important
</style>

<template>
  <div id="main">
	<div class="box">
		<div class="box-l">
			<div class="box-top">
				<div class="l-title">历史客户（{{history.length}}）</div>
			</div>
			<div class="box-list">
				<div v-for="(item,index) in history" :class="{active : hisCheckId == index}" class="list" @click="checkHisUser(item,index)">
					<img :src="$avatarHash(item.clientele_id)" >
					<div class="list-desc">
						<div class="list-name" :class="{active : hisCheckId == index }">{{item.clientele_name}}</div>
						<div class="list-mes" :class="{active : hisCheckId == index }">{{item.begin_time}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="box-r">
			<div class="box-r-l">
				<div class="info">
					<div>
						<div class="top-title">客户信息</div>
						<div class="info-title">基本信息</div>
						<div class="infos">
							<span class="infos-name">用&nbsp;&nbsp;户&nbsp;&nbsp;名：</span>
							<span class="infos-desc">{{infoForm.nickname}}</span>
						</div>
						<div class="infos">
							<span class="infos-name">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;域：</span>
							<span class="infos-desc">{{infoForm.consult_address}}</span>
						</div>
						<div class="infos">
							<span class="infos-name">会话时长：</span>
							<span class="infos-desc">{{infoForm.all_consult_use_time | formatSeconds}}</span>
						</div>
						<div class="infos">
							<span class="infos-name">来访次数：</span>
							<span class="infos-desc">{{infoForm.consult_count}}</span>
						</div>
						<div class="infos">
							<span class="infos-name">来源网址：</span>
							<span class="infos-desc">{{infoForm.consult_url}}</span>
						</div>
					</div>

					<div class="talk">
						<div class="talk-title">采集信息</div>
						<div class="talks">
							<span class="talk-name">公司名称：</span>
							<span class="talk-desc">{{consultFormInfo.company_name || nomes}}</span>
						</div>
						<div class="talks">
							<span class="talk-name">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</span>
							<span class="talk-desc">{{consultFormInfo.consult_name || nomes}}</span>
						</div>
						<div class="talks">
							<span class="talk-name">职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;务：</span>
							<span class="talk-desc">{{consultFormInfo.position || nomes}}</span>
						</div>
						<div class="talks">
							<span class="talk-name">手&nbsp;&nbsp;机&nbsp;&nbsp;号：</span>
							<span class="talk-desc">{{consultFormInfo.contact_phone || nomes}}</span>
						</div>
						<div class="talks">
							<span class="talk-name">所在园区：</span>
							<span class="talk-desc">{{consultFormInfo.address || nomes}}</span>
						</div>
						<div class="talks">
							<span class="talk-name">关注问题：</span>
							<span class="talk-desc" v-if="consultFormInfo.consult_tag_id" v-for="(item , i) in consultFormInfo.consult_tag_id">
								<span style="margin-right:5px">{{item | consultFormInfoTag(tagsList)}}</span>
								<span v-if="consultFormInfo.consult_tag_id.length != i+1">、</span>
							</span>
							<span v-if="!consultFormInfo.consult_tag_id"  class="talk-desc">未填写</span>
						</div>
					</div>

					<div class="talk">
						<div>
							<span class="talk-title">咨询总结</span>
							<i v-if="history.length" class="iconfont iconbi" @click="showConsultEdit" style="cursor:pointer"></i>
						</div>
						<div class="talks">
							<span class="talk-name">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</span>
							<span v-if="!showEdit" class="talk-desc">{{infoForm.name || nomes}}</span>
							<span v-if="showEdit">
								<el-input v-model="talkform.name" size="small" class="talk-input"></el-input>
							</span>
						</div>
						<div class="talks">
							<span class="talk-name">公司名称：</span>
							<span v-if="!showEdit" class="talk-desc">{{infoForm.company || nomes}}</span>
							<span v-if="showEdit">
								<el-input v-model="talkform.company" size="small" class="talk-input"></el-input>
							</span>
						</div>
						<div class="talks">
							<span class="talk-name">公司地址：</span>
							<span v-if="!showEdit" class="talk-desc">{{infoForm.address || nomes}}</span>
							<span v-if="showEdit">
								<el-input v-model="talkform.address" size="small" class="talk-input"></el-input>
							</span>
						</div>
						<div class="talks">
							<span class="talk-name">联系方式：</span>
							<span v-if="!showEdit" class="talk-desc">{{infoForm.phone || nomes}}</span>
							<span v-if="showEdit">
								<el-input v-model="talkform.phone" size="small" class="talk-input"></el-input>
							</span>
						</div>
						<div class="talks">
							<span class="talk-name">用户等级：</span>
							<span v-if="!showEdit" class="talk-desc">{{infoForm.grade || nomes}}</span>
							<span v-if="showEdit">
								<el-input v-model="talkform.grade" size="small" class="talk-input"></el-input>
							</span>
						</div>
						<div class="talks" style="display:flex">
							<div class="talk-name">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</div>
							<div v-if="!showEdit" class="talk-desc" style="overflow-y:auto;height:100px;margin-left:3px">{{infoForm.remark || nomes}}</div>
							<div v-if="showEdit" style="margin-left:3px">
								<el-input v-model="talkform.remark" size="small" class="talk-input"></el-input>
							</div>
						</div>
						<div  v-if="showEdit" class="btns">
							<el-button type="primary" size="mini" round @click="subZxEdit">保存</el-button>
							<el-button type="info" size="mini" round @click="notZxEdit">取消</el-button>
						</div>
					</div>
				</div>
				<div class="mes">
					<div>
						<div class="mes-title">互动记录</div>
						<el-timeline>
							<el-timeline-item v-if="recordList.length == 0">暂时没有记录哦</el-timeline-item>
							<el-timeline-item v-if="recordList" v-for="(item , index) in recordList" :key="index" type="primary">
								<p @click="checkRecord(item.record_id,index)" class="timeline-title"><span>客服{{item.support_staff}}</span>&nbsp;&nbsp;&nbsp;{{item.begin_time | timeconvert}}&nbsp;&nbsp;&nbsp;时长：{{item.use_time | formatSeconds}}</p>
							    <div v-if="recordId == index" class="timeline-list">
									<div v-for="(item , i) in messageList" class="timeline-lists">
										<div :class="{'isuser' : item.identity == 'client','iskf' : item.identity == 'support_staff','isls' : item.identity == 'lawyer',}">
											<span v-if="item.identity == 'client'">{{item.name}}</span>
											<span v-if="item.identity == 'lawyer'">律师 {{item.name}}</span>
											<span v-if="item.identity == 'support_staff'">客服{{item.from}}</span>
											&nbsp;&nbsp;&nbsp;{{item.time | timeconvert1}}</div>
										<div v-if="item.filetype">
											<div v-if="item.filetype == 'img'">
												<div v-viewer="{ 'navbar': false, 'toolbar': false, 'rotatable': false, 'scalable': false, 'keyboard': true}">
			                                        <img :title="item.filename" :src="`${imgUrl}/file/preview/${item.filesrc}/img`" style="max-width:220px;max-height:220px;display:block;cursor:pointer">
			                                    </div>
											</div>
											<div v-else-if="item.filetype == 'pay'" style="background:#f0f0f0;padding:2px 0;max-width:150px;border-radius:5px;text-align:center;">客服发起咨询付费邀请</div>
											<div v-else-if="item.filetype == 'com'" style="background:#f0f0f0;padding:2px 0;max-width:100px;border-radius:5px;text-align:center;">{{item.filename}}</div>
											<div v-else>
												<a v-if="item.filetype == 'doc' || item.filetype == 'ppt' || item.filetype == 'xls'" style="color:#000" target="_blank" title="点击预览文件" :href="`${imgUrl}/file/preview/${item.filesrc}`">{{item.filename}}</a>
												<span v-else style="color:#000">{{item.filename}}</span>
												<a style="color:#000" target="_blank" title="下载此文件" :href="`${imgUrl}/file/download/${item.filesrc}`">下载</a>
											</div>
										</div>
										<div v-else class="timeline-message" v-html="item.content"></div>
									</div>
								</div>
							</el-timeline-item>
						</el-timeline>
					</div>
				</div>
			</div>
		</div>
	</div>
  </div>
</template>

<script>
import moment from 'moment';
import {messageConvert} from '@/common/js/messageConvert';
export default {
	data() {
		return {
			imgUrl,
			messageConvert,
			history:[],
			hisCheckId:'0',
			infoForm:{
				name:'',
				address:'',
				all_consult_use_time:'',
				consult_count:'',
				web:''
			},
			talkform:{
				name:'',
				company:'',
				address:'',
				phone:'',
				grade:'',
				remark:''
			},
			nomes:'未填写',
			showEdit:false, //显示编辑
			recordList:[],
			messageList:[],  //互动记录详情
			recordId:'-1',  //显示互动会话
			clientele_id:'',  //选中的id
			consultFormInfo:{},  //客户咨询采集信息数据
			tagsList:[]  //采集信息中关注问题的列表
		}
	},
	computed: {
		
    },
	created() {

	},
	mounted() {
		this.getHisList();
		this.getTags();  //获取关注问题列表
		// this.getRecordList();
		// this.getConsultrecord();
	},
	methods: {

		//获取客户咨询采集信息
		getConsultFormInfo(){
			let url = 'wxm/consult/show';
			let params = {
				userid:this.clientele_id
			};
			this.$ajax('get',url,params,res => {
				if(res.retcode === 0){
					if(res.data){
						this.consultFormInfo = res.data;
						this.consultFormInfo.consult_tag_id  = this.consultFormInfo.consult_tag_id.split(",");
					}else{
						this.consultFormInfo = []
					}
				}
			})
		},
		//获取咨询采集信息里面关注问题列表
		getTags(){
			let url = 'wxm/consult/getTags';
			this.$ajax('get',url,res => {
				if(res.retcode === 0){
					this.tagsList = res.data;
				}
			})
		},

		//客服管理--客户记录列表
		getHisList(){
			let url = 'consultcenter/supportstaffmanage/historyclientelelist';
			this.$ajax('get' , url , res => {
				if (res.retcode === 0) {
					//排序
					// res.data.sort((a,b) => {
					// 	let atime = a.begin_time;
					// 	let btime = b.begin_time;
					// 	atime = atime.replace(/-/g,'/');
					// 	btime = btime.replace(/-/g,'/');
					// 	let atimes = new Date(atime).getTime();
					// 	let btimes = new Date(btime).getTime();
					// 	return btimes - atimes
					// })
		        	this.history = res.data;
		        	this.clientele_id = this.history[0].clientele_id;
		        	this.getRecordList(this.clientele_id);
		        	this.getConsultrecord(this.clientele_id);
		        	this.getConsultFormInfo();
		        } else {
		          this.$message.error(res.data.errmsg)
		        }
			})
		},
		//获取客户咨询记录列表
		getRecordList(id){
			let url = 'consultcenter/clientele/consultrecordlist';
			let params = {
				clientele_id:id,
				is_lawyer:0
			};
			this.$ajax('get' , url , params , res => {
				if (res.retcode === 0) {
		        	this.recordList = res.data;
		        } else {
		          this.$message.error(res.data.errmsg)
		        }
			})
		},
		//获取客户咨询记录详情
		getRecordInfo(id){
			let url = 'consultcenter/clientele/consultrecord';
			let params = {
				record_id:id,
			};
			this.$ajax('get' , url , params , res => {
				if (res.retcode === 0) {
		        	let list = res.data[0].consult_content;
		        	//将数据转换为数组
		        	this.messageList = list.replace(/},/g,"}}:,,").split("}:,,")
		        	for(var i=0;i<this.messageList.length;i++){
		        		this.messageList[i]=messageConvert(JSON.parse(this.messageList[i]))
		        	}
		        	//将数据按照时间排序
		        	this.messageList = this.timeSort(this.messageList,'time');
		        } else {
		          this.$message.error(res.data.errmsg)
		        }
			})
		},
		//按时间排序
		timeSort(array,key){
			return array.sort(function(a,b){
		     var x = a[key];
		     var y = b[key];
		     return ((x<y)?-1:(x>y)?1:0)
		    })
		},
		//获取客户信息
		getConsultrecord(id){
			let url = 'consultcenter/clientele/getinformation';
			let params = {
				clientele_id:id
			}
			this.$ajax('get' , url , params, res => {
				if (res.retcode === 0) {
					if(res.data == null){
		        		this.infoForm = {}
		        	}else{
		        		this.infoForm = res.data;
		        		console.log(this.infoForm);
		        	}
		        } else {
		          this.$message.error(res.data.errmsg)
		        }
			})
		},
		//选择历史用户
		checkHisUser(item,i){
			this.hisCheckId = i;
			this.clientele_id = item.clientele_id;
			this.showEdit = false;
			this.recordId = '-1';
			this.getRecordList(item.clientele_id);
        	this.getConsultrecord(item.clientele_id);
        	this.getConsultFormInfo();
		},
		//展开时间线对话
		checkRecord(id,i){
			if(i == this.recordId){
				this.recordId = '-1';
				this.messageList = [];
			}else{
				this.getRecordInfo(id);
				this.recordId = i;
			}
		},
		//打开编辑客户信息（咨询总结）
		showConsultEdit(){
			this.showEdit = true;
			this.talkform = {
				name:this.infoForm.name || '',
				company:this.infoForm.company || '',
				address:this.infoForm.address || '',
				phone:this.infoForm.phone || '',
				grade:this.infoForm.grade || '',
				remark:this.infoForm.remark || ''
			};
		},
		//编辑客户信息（咨询总结）
		subZxEdit(){
			let url='consultcenter/clientele/setinformation';
			let params = this.talkform;
			params.clientele_id = this.clientele_id;
			this.$ajax('post' , url , params, res => {
				if (res.retcode === 0) {
		        	this.$message.success('编辑客户信息成功!');
		        	this.getConsultrecord(this.clientele_id);
		        	this.showEdit = false;
		        } else {
		          this.$message.error(res.data.errmsg)
		        }
			})
		},
		//取消编辑客户信息（咨询总结）
		notZxEdit(){
			this.showEdit = false;
		},
	},
	watch: {
	
	},
	filters: {
		timeconvert(t){
			return moment(t).format('YYYY-MM-DD')
		},
		timeconvert1(t){
			return moment(t*1000).format('YYYY-MM-DD HH:mm:ss');
		},
		formatSeconds(t){
			if(t){
				var theTime = parseInt(t);
				var middle = 0;
				var hour = 0;
				if(theTime > 60){
					middle= parseInt(theTime/60);
					theTime = parseInt(theTime%60);
					if(middle> 60){
						hour= parseInt(middle/60);
						middle= parseInt(middle%60);
					}
				}
				if(parseInt(theTime) <10){
					theTime = '0'+theTime;
				}
				if(parseInt(middle) <10){
					middle = '0' + middle;
				}
				if(parseInt(hour) <10){
					hour = '0' + hour;
				}
				var result = hour + ':' + middle+ ':' + theTime;
				return result;
			}else{
				return '00:00:00';
			}
		},
		consultFormInfoTag(value , options){
			for(var i=0;i<options.length;i++){
				if(value == options[i].id){
					return options[i].tag_name;
				}
			}
		}
	},
	components: {
      
  },
}
</script>




// WEBPACK FOOTER //
// src/components/consult/customer/customerRecord.vue